function manageProductPagePrice(quantity){
  var activeVariantPrice = $('.product-form #ProductSelect-product-template option:selected').attr('data-v-p');
  if (quantity == null){
    var totalPrice = activeVariantPrice; 
  }
  else{
    var totalPrice = activeVariantPrice * quantity ; 
  }
  var price = theme.Currency.formatMoney(totalPrice, theme.moneyFormat);
  $('.product-single__meta .product__price .price__pricing-group .price__regular .price-item--regular').html(price);
}

function change_item(quantity,lineNo){
  jQuery.post('/cart/change.js', { quantity: quantity,id:lineNo }).done(function() {
    location.reload();
  })
  .fail(function() {
    alert( "Something went wrong.Please try again." );
  });
}

function cdk_count(){
  return $.ajax({
    url:  '/cart',
    type: "get",
    success:function(data) {
      var cdk_data_counts = $(data).find('#cdk_custom_ount_cart').attr('data-count');
      $('[cdk-cart-count]').text(cdk_data_counts);
    }
  }); 
}

$(document).ready(function(){
  //console.log('i am working now');

  $('.product-form .cdk-quantity').change(function(){
    var quantity = $(this).val();  
    manageProductPagePrice(quantity);
  })

  var quantity = $('.product-form .cdk-quantity').val();  
  manageProductPagePrice(quantity);

  $(document).on('change','.cdk_cart__qty_box select', function(){ 
    var quantity = $(this).val(); var id = $(this).attr('data-key');
    change_item(quantity,id);
  })
  
  cdk_count();

  $( document ).on('click', '.product-form__cart-submit', function() {
    var checkExist = setInterval(function() {
      if ($('.cart-popup-wrapper').hasClass('cart-popup-wrapper--hidden')) {
      }
      else{ 
        cdk_count();
        clearInterval(checkExist);
      }
    }, 100);
  });


})